import { createFileRoute, useLocation } from "@tanstack/react-router";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { z } from "zod/v4";
import { ArticleEditorLayout } from "@/components/stealth-writer/result";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";
import { historyDetailQueryOptions } from "@/lib/queries/detector/history_v1";

const searchSchema = z.object({
  history_id: z.string().optional(),
});

export const Route = createFileRoute("/_app/stealth-ai-writer/result")({
  component: RouteComponent,
  validateSearch: searchSchema,
  loaderDeps: ({ search: { history_id } }) => ({
    history_id,
  }),
  async loader({ context: { queryClient }, deps: { history_id } }) {
    await queryClient.prefetchQuery(userPlanQueryOptions);

    if (history_id) {
      await queryClient.prefetchQuery(historyDetailQueryOptions(history_id));
    }
  },
});

function RouteComponent() {
  const {
    state: { result: locationResult, fieldsData, parent_id },
  } = useLocation();

  const { history_id } = Route.useSearch();
  const historyEntity = useQuery({
    ...historyDetailQueryOptions(history_id!),
    enabled: !!history_id,
  });

  const plan = useSuspenseQuery(userPlanQueryOptions);

  const result = locationResult || historyEntity.data?.results;

  if (!result) {
    return <div>No result</div>;
  }

  // TODO: get @jmlhsynv to handle missing plan info
  return (
    <ArticleEditorLayout
      result={result}
      fieldsData={fieldsData ?? null}
      plan={plan.data.info!}
      entry_type="AI_WRITER"
      parent_id={parent_id ?? historyEntity.data?.parent_id}
    />
  );
}
